import { AuthViewModel } from "../viewmodels/AuthViewModel.js";
import { useSingleton } from "mvc-kit/react";
// src/modules/AuthWrapper2/hooks/useCurrentOrganization.ts
function useCurrentOrganization() {
	return useSingleton(AuthViewModel).state.identityInfo.organization;
}
export { useCurrentOrganization };

//# sourceMappingURL=useCurrentOrganization.js.map